export default {
	TABLE_TITLE: 'Product variant workplace relations',
	TIP: 'Scroll table to see more rows!',
	TABLE_FILTER_DATE: 'Date',
	CLEAR_TABLE_FILTES: 'Clear filters',
};
